package com.demo.portfolio_demo.components.model

data class Researches(
    val title: String,
    val subTitle: String,
    val link: String,
    val type: String
)
